<script setup>
import { onMounted, ref } from 'vue'
import { useAuthStore } from "@/store/auth";
import { useRouter } from "vue-router";
import { useStore } from "@/store";
import { t } from "@/utils/i18n"; // 전역 헬퍼 import

const props = defineProps({
  window: {
    type: Object,
    required: false,
  }
});

const authStore = useAuthStore();
const store = useStore();
const router = useRouter();

const username = ref('');
const password = ref('');

// 로그인 처리
const handleLogin = async () => {
  if (!username.value) {
    alert(t('아이디를 입력하세요.', 'Enter your ID.'));
    return;
  }

  if (!password.value) {
    alert(t('비밀번호를 입력하세요.', 'Enter your password.'));
    return;
  }

  await authStore.login(username.value, password.value);
};

// 초기 언어 설정 + 로그인된 경우 리다이렉트
onMounted(async () => {
  if (!localStorage.getItem('userLanguage')) {
    const browserLang = navigator.language.split('-')[0];
    const lang = browserLang === 'ko' ? 'ko' : 'en'; // 기본값은 en
    store.setUserLanguage(lang);
  }

  if (authStore.isAuthenticated) {
    await router.push({ name: 'ProjectList' });
  }
});
</script>

<template>
  <div id="loginPage">
    <img class="tc_logo" src="../assets/img/logo.svg" alt="tc logo" />

    <form @submit.prevent="handleLogin">
      <label for="id"></label>
      <input v-model="username" id="id" type="text" name="id" :placeholder="t('아이디', 'ID')" />

      <label for="pw"></label>
      <input v-model="password" id="pw" type="password" name="pw" :placeholder="t('비밀번호', 'Password')" />

      <button type="submit" :disabled="username === '' || password === ''" class="login_btn">
        <transition name="fade" mode="out-in">
          <span :key="store.userLanguage">{{ t('로그인', 'Login') }}</span>
        </transition>
      </button>
    </form>
  </div>
</template>
